import { defineStore } from "pinia";

export const useSessionTimeoutStore = defineStore("sessionTimeoutStore", {
  state: () => {
    return {
      LoginTime: 0,
      minutesRemaining: 60,
      sessionWarningMinutes: 10,
      LastUserActivityTime: new Date(),
    };
  },
});
